import { forwardRef } from 'react'

import { cn } from '../../../utils/cn'
import { Text, type TypographyVariant } from '../text/text'

/* Shared with control molecules (Switch) so the label tiers can't drift
   from the atom's. */
export const labelSizeToVariant = {
  sm: 'caption-lg',
  md: 'body-md',
  lg: 'body-lg'
} as const satisfies Record<string, TypographyVariant>

type LabelSize = keyof typeof labelSizeToVariant
/* No bold: the Ømni matrix has no bold on any tier Label can render
   (caption-lg / body-md / body-lg). */
type LabelWeight = 'medium' | 'semibold'

export type LabelProps = Omit<React.ComponentPropsWithRef<'label'>, 'as'> & {
  size?: LabelSize
  weight?: LabelWeight
}

export const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ size = 'sm', weight = 'medium', className, ...props }, ref) => (
    <Text
      ref={ref as React.Ref<HTMLElement>}
      as='label'
      variant={labelSizeToVariant[size]}
      weight={weight}
      data-slot='label'
      className={cn(
        'leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
        className
      )}
      {...props}
    />
  )
)
Label.displayName = 'Label'
